import { escapeHtml } from '@/common/utils/strings'

export const NEW_PROMPT_MAX_LENGTH = 3000

/**
 * Determines whether the user is allowed to submit a prompt in the AI Assistant form.
 *
 * Note: when `isAskDoc` is true and no documents are selected, the form still allows submission —
 * the backend will fall back to searching all documents in the room.
 */
export function canPostPrompt ({
  disabled,
  prompt,
  maxLength = NEW_PROMPT_MAX_LENGTH,
}: {
  disabled: boolean
  prompt: string
  maxLength?: number
}): boolean {
  if (disabled) return false
  const length = escapeHtml(prompt).length
  if (length === 0) return false
  if (length > maxLength) return false
  return true
}
